import RequestAbstract from "./RequestAbstract";

export default class TreatmentTasks extends RequestAbstract {
    get link() {
        return this.links.treatmentTasks;
    }

    async updateSort(info) {
        const res = await this.post(this.link + "/update-by-ids", info);
        return res;
    }

    getById(stageId) {
        const arr = [
            { field: "id", op: "=", value: +stageId },
        ];

        return this.getAllFiltered([arr]);
    }
}
